import { render } from "./Price.vue?vue&type=template&id=63327bb9&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import "./Price.vue?vue&type=style&index=0&id=63327bb9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63327bb9"]])

export default __exports__